import styled from '@emotion/styled';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Header = styled.div`
	max-width: 72rem;
	margin: 0 auto 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-transform: uppercase;
`;

const Title = styled.h2`
	font-size: 2rem;
	margin: 0;
`;

const Image = styled.img`
	width: 100%;
	height: 400px;
	object-fit: cover;
`;

export default function MapBlockDelta({ street }: { street: string }) {
	return (
		<Section id="map">
			<Header>
				<Title>Map</Title>
			</Header>
			<Image src={street} />
		</Section>
	);
}
